import { render, staticRenderFns } from "./BorderedTabs.vue?vue&type=template&id=66dd4d8d&"
import script from "./BorderedTabs.vue?vue&type=script&lang=js&"
export * from "./BorderedTabs.vue?vue&type=script&lang=js&"
import style0 from "./BorderedTabs.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabs,
})
